import { ReceiptLinesTable, StatusMessage } from '@krp/ui-kit'
import { formatMoney, formatQuantity } from '../../pricing/model/format'
import type { CashReceiptDetails } from '../model/types'

export interface CashReceiptLinesProps {
  data: CashReceiptDetails | undefined
  error: string | null
  /** Карточка товара 1С по ключу номенклатуры — та же, что из списка номенклатуры. */
  openProduct: (productKey: string) => void
  /** Главное фото товара по ключу номенклатуры. */
  photoOf: (productKey: string) => string
}

/** Товары чека 1С из прочитанного чека: компактная таблица, как список номенклатуры; товар с ключом открывает свою карточку. */
export function CashReceiptGoods({ data, openProduct, photoOf }: Pick<CashReceiptLinesProps, 'openProduct' | 'photoOf'> & { data: CashReceiptDetails }) {
  if (data.lines.length === 0) return <p>В чеке нет товаров</p>
  return <ReceiptLinesTable lines={data.lines.map((line) => {
    const key = line.productKey
    return {
      id: String(line.lineNumber),
      name: line.productName ?? (key === null ? 'товар не указан' : 'товар не найден в 1С'),
      quantity: formatQuantity(line.quantity),
      price: formatMoney(line.price),
      amount: formatMoney(line.amount),
      discount: line.discount === null || line.discount === 0 ? null : formatMoney(line.discount),
      ...(key === null ? {} : { photo: photoOf(key), open: () => openProduct(key) }),
    }
  })} />
}

/** Товары чека 1С под раскрытой строкой списка: пока чек читается — «читаем», отказ 1С — дословно. */
export function CashReceiptLines({ data, error, openProduct, photoOf }: CashReceiptLinesProps) {
  if (error !== null) return <StatusMessage kind="error" title="Не удалось прочитать чек" text={error} />
  if (data === undefined) return <StatusMessage kind="loading" title="Читаем товары чека…" />
  return <CashReceiptGoods data={data} openProduct={openProduct} photoOf={photoOf} />
}
